
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import ErrorBoundary from './components/ErrorBoundary';
import { Toaster } from './components/ui/toaster';
import NotFound from './pages/NotFound';
import ServerError from './pages/ServerError';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';

import Brochures from './pages/Brochures';
import AdminBrochures from './pages/AdminBrochures';
import AdminBulletin from './pages/AdminBulletin';
import AdminLogin from './pages/AdminLogin';
import ResetPassword from './pages/ResetPassword';
import CorporateGovernanceTech from './pages/CorporateGovernanceTech';
import ArbitrationADR from './pages/ArbitrationADR';
import FounderProfile from './pages/FounderProfile';
import Mentorship from './pages/Mentorship';
import Contact from './pages/Contact';
import MentorshipApplication from './pages/MentorshipApplication';
import PrivacyPolicy from './pages/PrivacyPolicy';
import MachineLearning from './pages/sectors/MachineLearning';
import AgenticAI from './pages/sectors/AgenticAI';
import GenerativeAI from './pages/sectors/GenerativeAI';
import ComputerVision from './pages/sectors/ComputerVision';
import NLPPrivacy from './pages/sectors/NLPPrivacy';
import RoboticsLegal from './pages/sectors/RoboticsLegal';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col">
        <Navigation />
        
        <main className="flex-1">
          <ErrorBoundary>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/ai-law-ethics" element={<Navigate to="/brochures" replace />} />
            <Route path="/brochures" element={<Brochures />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/admin/brochures" element={<AdminBrochures />} />
            <Route path="/admin/bulletin" element={<AdminBulletin />} />
            <Route path="/corporate-governance-tech" element={<CorporateGovernanceTech />} />
            <Route path="/arbitration-adr" element={<ArbitrationADR />} />
            <Route path="/founder-profile" element={<FounderProfile />} />
            <Route path="/mentorship" element={<Mentorship />} />
            <Route path="/mentorship-application" element={<MentorshipApplication />} />
            <Route path="/sectors/machine-learning" element={<MachineLearning />} />
            <Route path="/sectors/agentic-ai" element={<AgenticAI />} />
            <Route path="/sectors/generative-ai" element={<GenerativeAI />} />
            <Route path="/sectors/computer-vision" element={<ComputerVision />} />
            <Route path="/sectors/nlp-privacy" element={<NLPPrivacy />} />
            <Route path="/sectors/robotics-legal" element={<RoboticsLegal />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/500" element={<ServerError />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          </ErrorBoundary>
        </main>
        
        <Footer />
        <Toaster />
      </div>
    </Router>
  );
}

export default App;
